/*
 * @author: fackin
 * @Description
 * @Date: 2019-03-13 10:42:15
 * @LastEditTime: 2019-03-13 10:45:46
 */
export default {
  name: 'VqRow',

  componentName: 'VqRow',

  props: {
    tag: {
      type: String,
      default: 'div'
    },
    gutter: Number,
    type: String,
    justify: {
      type: String,
      default: 'start'
    },
    align: {
      type: String,
      default: 'top'
    }
  },

  computed: {
    style () {
      var ret = {};

      if (this.gutter) {
        ret.marginLeft = `-${this.gutter / 2}px`;
        ret.marginRight = ret.marginLeft;
      }

      return ret;
    }
  },

  render (h) {
    return h(this.tag, {
      class: [
        'vq-row',
        this.justify !== 'start' ? `is-justify-${this.justify}` : '',
        this.align !== 'top' ? `is-align-${this.align}` : '',
        { 'vq-row--flex': this.type === 'flex' }
      ],
      style: this.style
    }, this.$slots.default);
  }
};



// WEBPACK FOOTER //
// ./packages/row/src/row.js